<h4> {{ title | translate }} </h4>
<h3 class="form_note" *ngIf="!readonly"> {{ 'generic.attribute_update' | translate }} </h3>
<mat-progress-bar mode="indeterminate" *ngIf="attribute_loading"></mat-progress-bar>

<form #fo = "ngForm">
    
    <div fxLayout="row" *ngIf="!readonly">
    
        <mat-form-field fxFlex = "50">
            
            <mat-select [(ngModel)]="attribute_selected" name="attribute_selected" [disabled] = "attributes.length() === 0">
                <mat-option *ngFor="let aa of attributes.all()" [value]="aa">
                    {{ aa.name }}
                </mat-option>
            </mat-select>
            
        </mat-form-field>
        
        <mat-form-field fxFlex = "40" fxFlexOffset="1" >
            <input  matInput  type="text" [(ngModel)] = "attribute_value" name="attribute_value" placeholder="{{ 'generic.value' | translate }}"  >
        </mat-form-field>
        
        <div fxFlex = "10" fxFlexOffset="1" >
            <button class="tiny_icon" mat-button *ngIf="isAddable()" matSuffix mat-icon-button (click)="addOption()">
                <mat-icon>add_circle</mat-icon>
            </button>
        
        </div>
    
    </div>
    
    <div fxLayout="row" >
        <table class="mat-table mat-elevation-z1">
                    <thead>
                        <tr class="mat-header-row">
                            <th class="mat-header-cell"  > {{ 'generic.name' | translate }} </th>
                            <th class="mat-header-cell"   > {{ 'generic.value' | translate }} </th>
                            <th class="mat-header-cell" *ngIf="!readonly" > {{ 'generic.actions' | translate }} </th>
                        </tr>
                    </thead>
                    <tbody>
                    
                        <tr class="mat-row" *ngFor="let element of current_attributes.all(); let i = index;">
                            <td class="mat-cell" > {{ element.name }} </td>
                            <td class="mat-cell" > {{ element.value }} </td>
                            <!-- 
                            <td class="mat-cell" >  
                                <mat-form-field fxFlex = "100">
                                        <input  matInput  type="text" [(ngModel)] = "current_attributes.all()[i].value" placeholder="" name="a{{i}}" >
                                </mat-form-field>
                            </td>
                            -->
                            <td class="mat-cell" *ngIf="!readonly"> 
                                <button mat-icon-button (click)="removeOption(element.code)">
                                    <mat-icon  matTooltip="{{ 'generic.delete' | translate }}">delete</mat-icon>
                                </button>
                            </td>
                        </tr>
                    </tbody>
        </table>
        
    </div>
            
            
    <div fxLayout="row" *ngIf="!options.length" class="mat-elevation-z1 centered_spaced no-data-row" >
        {{ 'generic.norecord' | translate }}
    </div>
            
    
</form>